/**
 * @file camera-definition.ts
 * @module CameraDefinition
 * @description Mapbox GL stilu slāņu definīcijas satiksmes kamerām iegultajā kartē.
 *              Definē ikonu izmērus, redzamības tālummaiņas diapazonus un filtru
 *              nosacījumus aktīvo/neaktīvo kameru marķieriem.
 */

import type { LayerSpecification } from "maplibre-gl";

/** CMS device point layer: road condition monitoring stations with camera icon */
export const CAMERA_LAYER: LayerSpecification = {
	id: "cms_device",
	source: "pgtiles_2",
	"source-layer": "public.kafkamessages_cms",
	type: "symbol",
	paint: {
		"icon-opacity": 1,
	},
	filter: ["all", ["==", ["geometry-type"], "Point"], ["==", ["get", "status"], "active"]],
	layout: {
		"icon-image": "kamera-caurspidiga",
		"icon-rotation-alignment": "viewport",
		"icon-allow-overlap": true,
		"icon-ignore-placement": true,
	},
};

/** Traffic camera point layer: cameras from the separate camera Kafka topic */
export const CAMERA_LAYER_2: LayerSpecification = {
	id: "cms_device_2",
	source: "pgtiles_2",
	"source-layer": "public.kafkamessages_camera",
	type: "symbol",
	paint: {
		"icon-opacity": 1,
	},
	filter: ["all", ["==", ["geometry-type"], "Point"], ["==", ["get", "status"], "active"]],
	layout: {
		"icon-image": "kamera-caurspidiga",
		"icon-rotation-alignment": "viewport",
		"icon-allow-overlap": true,
		"icon-ignore-placement": true,
	},
};
